import React from "react";
import { JOB_MODE_LABELS, JOB_MODES } from "../services/jobService";

export function formatDate(value) {
  if (!value) return "N/A";
  const date = typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "N/A";
  return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export function DashboardSkeleton() {
  return (
    <div className="dashboard-skeleton">
      {Array.from({ length: 8 }).map((_, index) => (
        <div className="skeleton-line" key={index} />
      ))}
    </div>
  );
}

export function DashboardFilters({ search, status, mode, onSearchChange, onStatusChange, onModeChange }) {
  return (
    <div className="dashboard-filters">
      <label>
        <span>Search jobs</span>
        <input
          type="search"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Role, company, or job ID"
        />
      </label>
      <label>
        <span>Status</span>
        <select value={status} onChange={(event) => onStatusChange(event.target.value)}>
          <option value="ALL">All statuses</option>
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </label>
      <label>
        <span>Interview mode</span>
        <select value={mode} onChange={(event) => onModeChange(event.target.value)}>
          <option value="ALL">All modes</option>
          <option value={JOB_MODES.EXACT}>{JOB_MODE_LABELS[JOB_MODES.EXACT]}</option>
          <option value={JOB_MODES.AI_AROUND}>{JOB_MODE_LABELS[JOB_MODES.AI_AROUND]}</option>
          <option value={JOB_MODES.RANDOM}>{JOB_MODE_LABELS[JOB_MODES.RANDOM]}</option>
        </select>
      </label>
    </div>
  );
}
